import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { OwnersSearchFilterQuery } from "models/filters/owners/OwnersSearchFilterQuery";
import { OwnersApi } from "apis/OwnersApi";
import { Owner, OwnerView } from "models/dbModels/owners/Owner";

export const getOwners = createAsyncThunk("ownersSlice/getOwners", async (params?: OwnersSearchFilterQuery) => {
    const response = await OwnersApi.Search(params ?? {});
    return response.data;
});

export const getOwnerById = createAsyncThunk("ownersSlice/getOwnerById", async (id: number) => {
    const response = await OwnersApi.Search({ ids: [id] });
    return response.data;
});


export const UpdateOwner = createAsyncThunk("ownersSlice/updateOwner", async (owner: Owner) => {
    const response = await OwnersApi.Update([owner]);
    return response.data;
});

export const createOwner = createAsyncThunk("ownersSlice/createOwner", async (owner: Owner) => {
    const response = await OwnersApi.Add([owner]);
    return response.data;
});

type IntiialStateType = {
    owner: OwnerView;
    loading: boolean;
    table: OwnerView[];
    tableLoading: boolean;
};

const initialState: IntiialStateType = {
    owner: {
        id: 0,
        name: "",
        comments: "",
        created: new Date()
    },
    loading: false,
    table: [],
    tableLoading: false,
};

const ownersSlice = createSlice({
    name: "ownersSlice",
    initialState: initialState,
    reducers: {
        cleanOwnerDetails: (state) => {
            state.owner = {
                id: 0,
                name: "",
                created: new Date(),
            };
            state.loading = false;
        },
        updateField: (state, action) => {
            return {
                ...state,
                [action.payload.key]: action.payload.value,
            };
        },
        updateOwnerField: (state, action) => {
            return {
                ...state,
                owner: {
                    ...state.owner,
                    [action.payload.key]: action.payload.value,
                }
            };
        },
    },
    extraReducers: (builder) => {
        builder.addCase(getOwners.pending, (state) => {
            state.tableLoading = true;
        });
        builder.addCase(getOwners.fulfilled, (state, action) => {
            state.tableLoading = false;
            state.table = action.payload.data ? action.payload.data : [];
        });
        builder.addCase(getOwnerById.fulfilled, (state, action) => {
            state.owner = action.payload.data[0];
            state.loading = false;
        });
        builder.addCase(createOwner.fulfilled, (state, action) => {
        });
        builder.addCase(UpdateOwner.fulfilled, (state, action) => {
        });
    }
});


export const { cleanOwnerDetails, updateField, updateOwnerField } = ownersSlice.actions;

export default ownersSlice.reducer;